import { ModelMixin } from '../core/base-generic.model';
import { Employee } from '../employee/employee.model';
import { ApplicantInterviewers } from './applicant-interviewers.model';
import { ApplicantInterviews } from './applicant-interviews.model';
import { InterviewQuestion } from './interview-question.model';
import { JobPosting } from './job-posting.model';

export class Interview extends ModelMixin<Interview>() {
    protected static _resource = 'applicantTracker/interviews';
    protected static _version = 'v2';
    protected static _datetimes = ['createdAt', 'updatedAt', 'deletedAt'];
    protected static _serializeAttributes = ['atsJobId', 'name', 'description'];

    set id(val: number) {
        this._attributes['id'] = val;
    }

    get id(): number {
        return Number(this._attributes['id']) || null;
    }

    get atsJobId(): number {
        return this._attributes['atsJobId'];
    }

    set atsJobId(val: number) {
        this._attributes['atsJobId'] = val;
    }

    get name(): string {
        return this._attributes['name'];
    }

    set name(val: string) {
        this._attributes['name'] = val;
    }

    get description(): string {
        return this._attributes['description'];
    }

    set description(val: string) {
        this._attributes['description'] = val;
    }

    get interviewQuestions(): InterviewQuestion[] {
        return this.hasMany(InterviewQuestion, 'interviewQuestions');
    }

    set interviewQuestions(interviewQuestions: InterviewQuestion[]) {
        this.setMany('interviewQuestions', interviewQuestions);
    }

    get applicantInterviews(): ApplicantInterviewers[] {
        return this.hasMany(ApplicantInterviews, 'applicantInterviews');
    }

    get jobPosting(): JobPosting {
        return this.hasOne(JobPosting, 'jobPosting');
    }

    get updatedBy(): Employee {
        return this.hasOne(Employee, 'updatedBy');
    }
}
